import HeaderLogin from "../components/HeaderLogin"
import Footer from "../components/Footer"


const Contact = () => {
    return (
        <div>
            <HeaderLogin />
            <div className='d-flex w-100 flex-column justify-content-center align-items-start' style={{ marginTop: "5%", paddingLeft: "10%" }}>
                <h2>Contact Details</h2>
                <div className='d-flex flex-column'>
                    <h3>Texas Comptroller of Public Accounts</h3>
                    <a className="btn-link" href="mailto:bond.registration@cpa.texas.gov">bond.registration@cpa.texas.gov</a>
                    <a className="btn-link" href="tel:512-463-3890">512-463-3890</a>
                    <p>Office Address <br/>

                            Texas Comptroller of Public Accounts, Public Finance – Bond Registration <br/>

                            Thomas Jefferson Rusk Building<br/>

                            208 East 10th Street, Room 4.200 <br/>
                            Austin, TX 78701-2407 <br/>
   
                        Mailing Address <br/>

                             Texas Comptroller of Public Accounts, Public Finance – Bond Registration <br/>

                             P.O. Box 12608 <br/>

                             Austin, Texas 78711-2608</p>
                </div>
                <div className='d-flex flex-column' style={{ marginTop: '50px' }}>
                    <h3>Office of the Attorney General, Public Finance Division</h3>
                    <a className="btn-link" href="mailto:PFDSupport@oag.texas.go">PFDSupport@oag.texas.gov</a>
                    <a className="btn-link" href="tel:512-475-2929">512-475-2929</a>
                    <p>300 West 15th Street, Austin, Texas 78711</p>
                </div>
            </div>
            <div style={{marginTop: "9.5%"}}></div>
            <Footer isLoggedIn={"False"}/>
        </div >

    )
}

export default Contact